import { useState, useEffect } from "react";
import { ChevronDoubleUpIcon } from "@heroicons/react/24/outline";

const ScrollToUpBtn = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 600) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <button onClick={scrollToTop} className={`${isVisible ? 'opacity-100' : 'opacity-0'} fixed bottom-12 right-12 bg-pink-600 hover:bg-pink-700 focus:ring-pink-500 inline-flex items-center rounded-full p-3 text-white shadow-sm transition-opacity focus:outline-none focus:ring-2 focus:ring-offset-2`}>
      <ChevronDoubleUpIcon className="h-6 w-6" aria-hidden="true" />
    </button>
  );
};

export default ScrollToUpBtn;
